import {inject, DOM, customAttribute, bindable, bindingMode} from 'aurelia-framework';
import erd from 'element-resize-detector';
import {noop} from 'lodash';

@inject(DOM.Element)
@customAttribute('resizable')
export class Resizable {

  @bindable({
    primaryProperty: true,
    defaultBindingMode: bindingMode.oneTime
  }) resize = noop;

  @bindable({
    defaultBindingMode: bindingMode.oneTime
  }) condition = true;

  erd: erd.Erd;
  __targetEl: HTMLElement;

  constructor(element: Element) {
    /**
     * @type {Element}
     * @private
     */
    this.__targetEl = element as any;

    this.erd = erd({strategy: 'scroll'});
  }

  bind() {
    if (this.condition) {
      this.erd.listenTo(this.__targetEl, () => {
        this.resize();
      });
    }
  }

  unbind() {
    if (this.condition) {
      this.erd.uninstall(this.__targetEl);
    }
  }

}
